import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "file-jpg",
  "use": "file-jpg-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol viewBox=\"0 0 512 512\" id=\"file-jpg\"><path d=\"M224 400H70c-19 0-32-13-32-32V237c0-16 13-32 32-32h308c19 0 32 13 32 32v128c0 19-13 32-32 32-52 3-103 3-154 3zm83-67c-16 6-29 0-32-16-3-10-3-16 0-26 3-6 13-13 23-13 9 0 16 4 25 4 3-7 7-13 7-20-16-6-32-9-48-3-20 3-29 16-32 35 0 10-4 16 0 26 3 22 16 35 35 38 16 4 32 0 48-3 0 0 3-3 3-6v-45-6h-42v19h16c-3 6-3 13-3 16zm-118 22v-16-16c6 0 13 0 19-3 16 0 26-13 26-29 0-19-7-29-23-32s-32-3-48-3v99h26zm-48-99h-26v102c0 7-3 10-9 10H96v22h16c16 0 26-9 29-25 3-10 3-16 3-26-3-29-3-54-3-83zm-45-64H80v-38V32c0-19 13-32 32-32h243c3 0 7 0 10 3 35 35 70 71 105 106 4 3 4 6 4 6v362c0 19-13 32-32 32H112c-19 0-32-13-32-32v-55-6h16v58c0 12 6 19 19 19h330c9 0 16-7 16-19V314 118c0-6-3-9-10-9h-57c-20 0-32-13-32-32V19c0-6-4-9-10-9H115c-13 6-19 12-19 25v157zm339-93c-19-19-38-41-61-61v45c0 10 7 16 16 16h45zM205 294c0-3 3-9 0-12-3-4-10-4-16-4v23c6 0 13 0 16-7z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/file-jpg.svg
// module id = 185
// module chunks = 0